<script>
/* eslint-disable */
export default {
    name: "transaction",

    data(){
        return{

        }
    },
    methods: {
        ouvrirApaym(){
            let url = "apaym://apaym.com/transaction/";
            // let url = "https://apaym.com/nos-cartes/";
            window.open(url+this.$route.params.id, "_self")
        }
    },
    mounted(){
        console.log(this.$route.params.id);
        this.ouvrirApaym();
    },
}
</script>

<template>
<div>
<!--    <h1>id: {{this.$route.params.id}}</h1>-->
    <div class="col-lg-10 offset-lg-1">
        <div class="press-txt text-center m-top-20">

            <!-- Text -->
            <!-- Button -->
            <button @click="ouvrirApaym"  class="btn btn-lightorange ">
                Ouvrir l'application APAYM
            </button>

        </div>
    </div>
</div>
</template>

<style scoped>

</style>